import React from 'react';
import SectionHeader from '../common/SectionHeader';
import Card from '../common/Card';
import MarkersChart from '../charts/MarkersChart';

const MarkersOverview: React.FC = () => {
    return (
        <section className="space-y-4">
            <div className="flex justify-between items-center">
                <SectionHeader title="Your Markers At A Glance" />
            </div>
            <Card variant="elevated" rounded="3xl">
                <div className="pt-6">
                    <MarkersChart />
                </div>
            </Card>
        </section>
    );
};

export default MarkersOverview;
